import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';
import type { PlayButtonRef } from '../../atoms/play-button/PlayButton.data';
import type { PrimaryButtonRef } from '../../atoms/primary-button/PrimaryButton.data';

interface HeaderStandardRefs {
  elementRef?: RefObject<HTMLElement | null>;
  titleRef?: RefObject<HTMLHeadingElement | null>;
  subtitleRef?: RefObject<HTMLHeadingElement | null>;
  descriptionRef?: RefObject<HTMLHeadingElement | null>;
  playButtonRef?: RefObject<PlayButtonRef | null>;
  mediaHolderRef?: RefObject<HTMLDivElement | null>;
  siteHeaderElementRef?: RefObject<HTMLElement | null>;
  buttonRef?: RefObject<PrimaryButtonRef | null>;
}

export function showText(
  { titleRef, subtitleRef, descriptionRef, siteHeaderElementRef }: HeaderStandardRefs,
  show: boolean,
): void {
  const titleController = findTransitionController(titleRef);
  const subtitleController = findTransitionController(subtitleRef);
  const descriptionController = findTransitionController(descriptionRef);
  const headerController = findTransitionController(siteHeaderElementRef);
  const transitionMethod = show ? 'transitionIn' : 'transitionOut';

  if (titleController) {
    titleController[transitionMethod]();
  }
  if (subtitleController) {
    subtitleController[transitionMethod]();
  }
  if (descriptionController) {
    descriptionController[transitionMethod]();
  }
  if (headerController) {
    headerController[transitionMethod]();
  }
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  {
    titleRef,
    subtitleRef,
    descriptionRef,
    playButtonRef,
    mediaHolderRef,
    buttonRef,
  }: HeaderStandardRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const subtitleController = findTransitionController(subtitleRef);
  const descriptionController = findTransitionController(descriptionRef);
  const playButtonController = findTransitionController(playButtonRef);
  const button = findTransitionController(buttonRef);

  if (mediaHolderRef?.current) {
    timeline.fromTo(
      mediaHolderRef?.current,
      { scale: 1.1, opacity: 0 },
      { scale: 1, ease: 'Quad.easeOut', duration: 0.6, opacity: 1 },
    );
    // timeline.add(fadeFromTo(mediaHolderRef?.current), 0);
  }

  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, '<-0.2');
  }

  if (subtitleController) {
    timeline.add(subtitleController.getTimeline('in') as gsap.core.Timeline, '>-0.2');
  }

  if (descriptionController) {
    timeline.add(descriptionController.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }

  if (playButtonController) {
    timeline.add(playButtonController.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }

  if (button) {
    timeline.add(button.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }
}
